export type DeviceSimple = { serialNumber: string };

export enum DeviceStatus {
  installed = 'installed',
  not_installed = 'not_installed',
  pending = 'pending'
}

export enum InsuranceStatus
{
  insured = 'insured',
  registered = 'registered',
}

export type DeviceStatusType = DeviceStatus.installed | DeviceStatus.not_installed | DeviceStatus.pending;
export type InsuranceStatusType = InsuranceStatus.insured | InsuranceStatus.registered;

export type Device = {
  orderNumber: string;
  id: string;
  serialNumber: string;
  deliverDate?: string;
  status: DeviceStatusType;
  partnerId: string;
  customerId: string;
  applyInsurance: boolean;
  articleNumber: string;
  articleName: string;
  pairsWithArticleNumber?: string;
  allowRegistration: boolean;
  registrationId?: string;
};

export type DeviceMetaData = {
  id: string;
  serialNumber: string;
  articleName: string;
  customerId: string;
  partnerId?: string;
  deliverDate?: string;
  allowRegistration: boolean;
  insurance?: InsuranceMetaData;
};

export type InsuranceMetaData = {
  insuranceNumber: string;
  status: InsuranceStatusType;
  startDate: string;
  endDate: string;
};
